/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import { useEffect, useMemo } from 'react';

import { ExclamationCircleFilled } from '@ant-design/icons';
import { Button, Modal, Popover } from 'antd';
import queryString from 'query-string';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ResponsiveComponent } from '../../../utils/functions';
import TableColumnSearch from '../../../components/Input/TableColumnSearch';
import {
  ActionDeleteExercise,
  ActionGetExerciseList,
} from '../../../store/Actions/MasterDataAction';
import { matchPermissions } from '../../../utils/Permission';
import { PERMISSIONS } from '../../../constants';
import { TableListPageCom } from '../../../components/TableListPageCom';

const { confirm } = Modal;

const Exercise = () => {
  const { loader, exercise } = useSelector(state => state?.MasterData);
  const { userDetails } = useSelector(state => state?.auth);
  const [showArrow, setShowArrow] = useState(true);
  const [Refresh, setRefresh] = useState(false);
  const [arrowAtCenter, setArrowAtCenter] = useState(false);
  const [IsSearching, setIsSearching] = useState(false);
  const pageSize = 10;
  const dispatch = useDispatch();
  const location = useLocation();
  const params = queryString.parse(location.search);
  const Size = ResponsiveComponent();
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [SearchList, setSearchList] = useState([]);
  const mergedArrow = useMemo(() => {
    if (arrowAtCenter)
      return {
        pointAtCenter: true,
      };
    return showArrow;
  }, [showArrow, arrowAtCenter]);
  const handleSearch = (selectedKeys, dataIndex) => {
    setSearchText(selectedKeys?.[0]);
    setSearchedColumn(dataIndex);

    if (params[dataIndex]) {
      window.location.replace(`/exercise?page=1&filterlist=true&${dataIndex}=${selectedKeys?.[0]}`);
    } else {
      window.location.replace(`/exercise?${location.search}&${dataIndex}=${selectedKeys?.[0]}`);
    }
  };
  const handleReset = clearFilters => {
    clearFilters();
    setSearchText('');
    window.location.replace(`?page=1`);
  };
  const matchPermissionsForUser = matchPermissions(userDetails);
  const canView = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.EXERCISE.VIEW);
  const canUpdate = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.EXERCISE.UPDATE);
  const canDelete = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.EXERCISE.DELETE);
  const canCerate = matchPermissionsForUser(PERMISSIONS.MASTER_DATA.EXERCISE.CREATE);

  const content = item => (
    <div className="">
      {canUpdate && (
        <Button className="m-2" onClick={() => EditList(item?.id)}>
          Edit
        </Button>
      )}
      {canDelete && <Button onClick={() => showDeleteConfirm(item)}>Delete</Button>}
    </div>
  );
  const columns = [
    {
      title: 'Sr',
      dataIndex: 'sr',
      // key: "Sr",
      render: (text, record, index) => {
        const currentPage = parseInt(params?.page) || 1;
        const calculatedIndex = (currentPage - 1) * pageSize + index + 1;
        return <span>{calculatedIndex}</span>;
      },
    },
    {
      title: 'Order Index',
      dataIndex: 'orderIndex',
      render: (text, record) => <span>{record.orderIndex}</span>,
      ...TableColumnSearch({
        dataIndex: 'orderIndex',
        setSearchText,
        setSearchedColumn,
        handleReset,
        handleSearch,
      }),
    },
    {
      title: 'Title',
      dataIndex: 'title',
      render: (text, record) => <span>{record.title}</span>,
      ...TableColumnSearch({
        dataIndex: 'title',
        setSearchText,
        setSearchedColumn,
        handleReset,
        handleSearch,
        filtered: params?.title,
      }),
      sorter: (a, b) => a.title.length - b.title.length,
    },
    {
      title: !canDelete && !canUpdate ? null : 'Action',
      dataIndex: 'id',
      key: 'action',
      render: (text, record, num) => {
        if (!canDelete && !canUpdate) {
          return null;
        } else {
          return (
            <Popover
              placement="left"
              title={record.title}
              content={() => content(record)}
              arrow={mergedArrow}
            >
              <Button type="dashed">• • •</Button>
            </Popover>
          );
        }
      },
    },
  ];
  // const OrderIndex = params?.orderIndex ? `&orderIndex=${params?.orderIndex}` : ''
  // const Title = params?.title ? `&title=${params?.title}` : ''
  // const Final = OrderIndex + Title || ''

  useEffect(() => {
    dispatch(ActionGetExerciseList({ Query: `?page=${params?.page || 1}` }));
    setRefresh(false);
  }, [dispatch, params?.page, Refresh]);

  const handleSearch1 = searchTerm => {
    var newp = params;
    newp.page = searchTerm;
    window.location.href = window.location.pathname + '?' + queryString.stringify(newp);
  };

  const EditList = searchTerm => {
    window.location.href = `/exercise/add-exercise?update=true&&id=${searchTerm}&&page=${parseInt(params.page)}`;
  };

  const showDeleteConfirm = item => {
    confirm({
      title: `Are you sure delete this ${item?.id}?`,
      icon: <ExclamationCircleFilled />,
      content: '',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      zIndex: 1200,
      centered: true,
      onOk() {
        dispatch(
          ActionDeleteExercise('/' + item?.id, Res => {
            if (Res === 200) {
              setRefresh(true);
            }
          })
        );
      },
      onCancel() {
        return
      },
    });
  };
  const BreadcrumbList = [
    {
      name: 'Exercise',
      linkTo: `/exercise?page=${params?.page || 1}`,
    },
    {
      name: 'Exercise List',
    },
  ];
  return canView ? (
    <TableListPageCom
      BreadcrumbList={BreadcrumbList}
      TableData={exercise?.docs}
      TableColumn={columns}
      ShowAddButton={true}
      Iscreate={PERMISSIONS.MASTER_DATA.EXERCISE.CREATE}
      CreateButtonLink={`/exercise/add-exercise`}
      PageMainTitle="Exercise List"
      CurrentPage={exercise?.page || 1}
      Tableloader={loader}
      TotalPageList={exercise?.totalDocs}
      dataSourceLength={exercise?.docs?.length}
      handlePageChange={v => {
        var newp = params;
        newp.page = v;
        window.location.href = window.location.pathname + '?' + queryString.stringify(newp);
      }}
    />
  ) : (
    <div className="permission-denied-message">
      You do not have permission to view Exercise list.
    </div>
  );

};

export default Exercise;
